function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var app = {};
app.apply = function (object, config, defaults) {
  if (defaults) {
    app.apply(object, defaults);
  }
  if (object && config && _typeof(config) === 'object') {
    var i;
    for (i in config) {
      if (config.hasOwnProperty(i)) {
        object[i] = config[i];
      }
    }
  }
  return object;
};
app.apply(app, {
  corePlugins: {},
  helpers: {},
  plugins: {},
  options: {},
  viewListeners: null,
  area: {},
  views: {}
});
window.app = app;
export default app;